import { useState } from "react";
import { useTranslation } from "react-i18next";
import type { Column } from "react-table";
import styled from "styled-components";
import { TransactionsTable } from "../../components/tables/PaginatedTable";
import { useTokenDetails } from "../../context/token-details-context";
import { useGetCBTransactionHistory } from "../../hooks/useWallets";
import type { Transaction } from "../../services/wallet-service";
import { getTransactionsTableColumnConfig } from "../wallet/table-config";

const Wrapper = styled.div`
  margin-top: 24px;
`;

export const InternalTransactionsTable = (): JSX.Element => {
	const [queryPageIndex, setQueryPageIndex] = useState(0);
	const [queryPageSize, setQueryPageSize] = useState(10);

	const {
		// biome-ignore lint/suspicious/noExplicitAny: <explanation>
		data = [] as any,
		isLoading: isLoadingTransactions,
		isFetching,
		isPreviousData,
	} = useGetCBTransactionHistory("Internal", queryPageIndex, queryPageSize);

	const transactions = data?.transactions || [];
	const { t } = useTranslation();

	const { tokenDetails } = useTokenDetails();

	const tokenSymbol = tokenDetails?.[0].symbol;

	return (
		<Wrapper>
			<TransactionsArea>
				<TransactionsTable<Transaction>
					columnConfig={getTransactionsTableColumnConfig(t, tokenSymbol)}
					loading={isLoadingTransactions || isFetching}
					totalPages={data?.totalPages}
					rowData={transactions}
					getColumnProps={columnPropGetter}
					hideFilters
					queryPageIndex={queryPageIndex}
					queryPageSize={queryPageSize}
					setQueryPageIndex={setQueryPageIndex}
					setQueryPageSize={setQueryPageSize}
					totalItems={data?.totalItems}
					isPreviousData={isPreviousData}
				/>
			</TransactionsArea>
		</Wrapper>
	);
};

const columnPropGetter = (col: Column<Transaction>) => {
	const { id } = col;
	let textAlign: "start" | "end";
	switch (id) {
		case "Transaction ID":
			textAlign = "end";
			break;
		default:
			textAlign = "start";
			break;
	}
	return {
		style: {
			textAlign,
		},
	};
};

const TransactionsArea = styled.div`
  margin-top: 50px;
  position: relative;
`;
